import { render } from "./formularioLogin.vue?vue&type=template&id=0a76699d"
import script from "./formularioLogin.vue?vue&type=script&lang=js"
export * from "./formularioLogin.vue?vue&type=script&lang=js"

import "./formularioLogin.vue?vue&type=style&index=0&id=0a76699d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__